import { useDisplayContext } from '~src/context/DisplayContext';

import { Boiler, EnergyHouse, EnergyStation, HeatPumpWithBox, Radiator, Solar, SolarPanel } from './Image';

type Props = {
  solarPanel?: boolean;
  heatPump?: boolean;
  chargingStation?: boolean;
  width?: number;
  height?: number;
};

export const EnergyPotential = ({
  solarPanel = false,
  heatPump = false,
  chargingStation = false,
  width,
  height,
}: Props) => {
  const { isMobile } = useDisplayContext();

  const maxHeight = isMobile ? 170 : 406;
  const maxWidth = isMobile ? 310 : 732;

  const widthByHeight = height ? (maxWidth / maxHeight) * height : maxWidth;

  const energyHouseWidth = width ? width : widthByHeight;
  const energyHouseHeight = (maxHeight / maxWidth) * energyHouseWidth;

  const solarPanelWidth = (81 / 732) * energyHouseWidth;
  const solarWidth = (81 / 732) * energyHouseWidth;
  const energyStationWidth = (98.5 / 732) * energyHouseWidth;
  const heatPumpWithBoxWidth = (88 / 732) * energyHouseWidth;
  const boilerWidth = (72 / 732) * energyHouseWidth;
  const radiatorWidth = (61 / 732) * energyHouseWidth;

  return (
    <div style={{ position: 'relative' }}>
      <EnergyHouse width={energyHouseWidth} height={energyHouseHeight} />
      {solarPanel && (
        <SolarPanel
          width={solarPanelWidth}
          height={(80 / 85) * solarPanelWidth}
          style={{ position: 'absolute', left: (527 / 732) * energyHouseWidth, top: (70 / 406) * energyHouseHeight }}
        />
      )}
      {solarPanel && (
        <Solar
          width={solarWidth}
          height={solarWidth}
          style={{ position: 'absolute', left: (600 / 732) * energyHouseWidth, top: 0 }}
        />
      )}
      {chargingStation && (
        <EnergyStation
          width={energyStationWidth}
          height={(91 / 98.5) * energyStationWidth}
          style={{ position: 'absolute', left: (640 / 732) * energyHouseWidth, bottom: (18 / 406) * energyHouseHeight }}
        />
      )}
      {heatPump && (
        <HeatPumpWithBox
          width={heatPumpWithBoxWidth}
          height={(83 / 88) * heatPumpWithBoxWidth}
          style={{ position: 'absolute', left: (20 / 732) * energyHouseWidth, bottom: (23 / 406) * energyHouseHeight }}
        />
      )}
      {heatPump && (
        <Boiler
          width={boilerWidth}
          height={(126 / 72) * boilerWidth}
          style={{ position: 'absolute', left: (160 / 732) * energyHouseWidth, bottom: (18 / 406) * energyHouseHeight }}
        />
      )}
      {heatPump && (
        <Radiator
          width={radiatorWidth}
          height={(78 / 61) * radiatorWidth}
          style={{ position: 'absolute', left: (355 / 732) * energyHouseWidth, bottom: (11 / 406) * energyHouseHeight }}
        />
      )}
    </div>
  );
};
